import React from "react";
import { HiddenInputProps } from "./HiddenInput.types";

export const HiddenInput = React.forwardRef<HTMLInputElement, HiddenInputProps>(
  (props, ref) => {
    return <input {...props} type="hidden" ref={ref} />;
  }
);

HiddenInput.displayName = "HiddenInput";
